import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { create } from "zustand";
import { devtools } from "zustand/middleware";
/** Holds unsent task comment drafts so they survive the task detail being minimised/unmounted. */
export var useCommentDraftStore = create()(devtools(function (set) {
  return {
    drafts: {},
    setDraft: function setDraft(reminderId, text) {
      return set(function (s) {
        return {
          drafts: _objectSpread(_objectSpread({}, s.drafts), {}, _defineProperty({}, reminderId, text))
        };
      }, false, "setDraft");
    },
    clearDraft: function clearDraft(reminderId) {
      return set(function (s) {
        var next = _objectSpread({}, s.drafts);
        delete next[reminderId];
        return {
          drafts: next
        };
      }, false, "clearDraft");
    }
  };
}, {
  name: "CommentDraftStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));